<template>
<div class="vpn-home">
  <HeadNav :selectedLanguage="navLocale" page="home" />
  <main class="vpn-home__main">
    <HeroSection
      :title="heroProps.title"
      :description="heroProps.description"
      :points="heroProps.points"
      :cta-label="heroProps.ctaLabel"
    />
    <FeaturesSection />
    <ExtraFeaturesSection />
    <PrivacySection />
    <DailyUseSection />
    <InstallStepsSection />
    <CompareSection />
    <PrivacyChoiceSection />
    <TestimonialsSection />
    <FaqSection :title="faqTitle" :items="faqItems" />
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';
import HeroSection from '@/components/vpn/HeroSection.vue';
import FeaturesSection from '@/components/vpn/FeaturesSection.vue';
import ExtraFeaturesSection from '@/components/vpn/ExtraFeaturesSection.vue';
import PrivacySection from '@/components/vpn/PrivacySection.vue';
import DailyUseSection from '@/components/vpn/DailyUseSection.vue';
import InstallStepsSection from '@/components/vpn/InstallStepsSection.vue';
import CompareSection from '@/components/vpn/CompareSection.vue';
import PrivacyChoiceSection from '@/components/vpn/PrivacyChoiceSection.vue';
import TestimonialsSection from '@/components/vpn/TestimonialsSection.vue';
import FaqSection from '@/components/vpn/FaqSection.vue';
import { getHomeContent } from '@/data/vpnHomeContent';

export default {
  name: 'Home',
  components: {
    HeadNav,
    HeroSection,
    FeaturesSection,
    ExtraFeaturesSection,
    PrivacySection,
    DailyUseSection,
    InstallStepsSection,
    CompareSection,
    PrivacyChoiceSection,
    TestimonialsSection,
    FaqSection,
  },
  data() {
    return {
      vpnHomeContent: null,
    };
  },
  provide() {
    return {
      vpnHomeContentRoot: this,
    };
  },
  computed: {
    navLocale() {
      return this.$route.meta.localeKey || 'en';
    },
    heroProps() {
      if (!this.vpnHomeContent) {
        return {
          title: undefined,
          description: undefined,
          points: undefined,
          ctaLabel: undefined,
        };
      }
      return {
        title: this.vpnHomeContent.h1,
        description: this.vpnHomeContent.heroLead,
        points: this.vpnHomeContent.heroPoints,
        ctaLabel: this.vpnHomeContent.heroCtaLabel,
      };
    },
    faqTitle() {
      return this.vpnHomeContent ? this.vpnHomeContent.faqTitle : undefined;
    },
    faqItems() {
      if (!this.vpnHomeContent) {
        return undefined;
      }
      return this.vpnHomeContent.faqs;
    },
  },
  watch: {
    '$route.meta.localeKey': {
      immediate: true,
      handler(localeKey) {
        this.vpnHomeContent = localeKey ? getHomeContent(localeKey) : null;
      },
    },
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site');
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('vpn-site');
    }
  },
};
</script>

<style lang="scss" scoped>
.vpn-home {
  min-height: 70vh;
  background: transparent;
  max-width: 100%;
  overflow-x: hidden;
}

.vpn-home__main {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}
</style>
